function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

// Handlers partagés par trapFocus / removeTrapFocus (déclaration manquante depuis Dawn)
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    console.log('[VariantSelects] Constructor called');
    this.addEventListener("change", this.onVariantChange.bind(this));
    console.log('[VariantSelects] Change listener attached');
  }

  onVariantChange(event) {
    console.log('[VariantSelects] onVariantChange called', event);

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    this.updateCurrentVariantCard();
    this.updateMediaVariant();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();

    if (this.dataset.selectedVariantId) {
      const variantId = parseInt(this.dataset.selectedVariantId);
      console.log('[VariantSelects] Using selected variant ID:', variantId);

      this.currentVariant = variantData.find((variant) => variant.id === variantId);

      if (this.currentVariant) {
        console.log('[VariantSelects] Found variant by ID:', this.currentVariant);
        return;
      } else {
        console.warn('[VariantSelects] Variant ID not found, falling back to option matching');
      }
    }

    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    console.log('[VariantSelects] updateMedia called', {
      hasVariant: !!this.currentVariant,
      variant: this.currentVariant,
      hasFeaturedMedia: this.currentVariant?.featured_media
    });

    if (!this.currentVariant) {
      console.warn('[VariantSelects] No currentVariant, skipping updateMedia');
      return;
    }

    if (this.currentVariant.featured_media) {
      const mediaGallerySelector = `[id^="MediaGallery-${this.dataset.section}"]`;
      console.log('[VariantSelects] Looking for media galleries:', mediaGallerySelector);

      const mediaGalleries = document.querySelectorAll(mediaGallerySelector);
      console.log('[VariantSelects] Found media galleries:', mediaGalleries.length);

      mediaGalleries.forEach((mediaGallery) => {
        const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        console.log('[VariantSelects] Setting active media:', mediaId);
        mediaGallery.setActiveMedia(mediaId, true);
      });
    } else {
      console.log('[VariantSelects] No featured_media, trying alternative image update method');
    }

    const productMedias = document.querySelector('product-medias');
    if (productMedias && this.currentVariant.option1) {
      console.log('[VariantSelects] Updating product-medias for option:', this.currentVariant.option1);

      const allImages = productMedias.querySelectorAll('.image__variant');
      console.log('[VariantSelects] Found variant images:', allImages.length);

      allImages.forEach(img => img.classList.remove('selected'));

      const variantImage = Array.from(allImages).find(img => {
        const alt = img.getAttribute('alt');
        if (!alt) return false;

        const options = alt.split(',').map(s => s.trim()).filter(s => s);
        const matches = options.includes(this.currentVariant.option1);

        console.log('[VariantSelects] Checking image alt:', { alt, options, searching: this.currentVariant.option1, matches });

        return matches;
      });

      if (variantImage) {
        console.log('[VariantSelects] Found matching image, setting as selected');
        variantImage.classList.add('selected');
        variantImage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        console.warn('[VariantSelects] No matching image found for option:', this.currentVariant.option1);
      }
    }

    if (this.currentVariant.featured_media) {
      const modalContent = document.querySelector(
        `#ProductModal-${this.dataset.section} .product-media-modal__content`
      );
      if (modalContent) {
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`
        );
        if (newMediaModal) {
          modalContent.prepend(newMediaModal);
        }
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.querySelector(`.price__container`);

        price.innerHTML = html.querySelector(".price__container").innerHTML;

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonSticky = document.querySelector(".add-to-cart-sticky");
    const productFormAvailability = document.querySelector(
      ".product-form__availability "
    );

    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      if (addButtonSticky && text) addButtonSticky.textContent = text;
      productFormAvailability.classList.add("hidden");
    } else {
      addButton.removeAttribute("disabled");
      if (addButtonSticky) addButtonSticky.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
      if (addButtonSticky)
        addButtonSticky.textContent = window.variantStrings.addToCart;
      productFormAvailability.classList.remove("hidden");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonSticky = document.querySelector(".add-to-cart-sticky");
    let productFormAvailability = document.querySelector(
      ".product-form__availability "
    );

    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (addButtonSticky)
      addButtonSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateCurrentVariantCard() {
    this.querySelectorAll(".product-form-collection__card").forEach((card) => {
      card.classList.toggle(
        "actif",
        card.dataset.variantId === this.currentVariant.id.toString()
      );
    });
  }

  updateMediaVariant() {
    console.log('[VariantSelects] updateMediaVariant called');

    if (!this.currentVariant || !this.currentVariant.option1) {
      console.warn('[VariantSelects] No currentVariant or option1, skipping updateMediaVariant');
      return;
    }

    const active_item = this.currentVariant.option1;
    console.log('[VariantSelects] Looking for variant images with option:', active_item);

    const variants_image = document.querySelectorAll(".image__variant");
    console.log('[VariantSelects] Found images:', variants_image.length);

    let variant_image = null;
    variants_image.forEach((img) => {
      const alt = img.getAttribute('alt');
      if (alt && alt.split(',').map(s => s.trim()).includes(active_item)) {
        variant_image = img;
      }
    });

    if (variant_image) {
      console.log('[VariantSelects] Found matching variant image, updating swiper slides');

      // variants_image.forEach((item) => {
      //   if (item.closest(".swiper-slide-item") && !item.closest(".image__global")) {
      //     item.closest(".swiper-slide-item").classList.add("hidden");
      //     item.closest(".swiper-slide-item").classList.remove("selected", "swiper-slide");
      //   }
      //   item.classList.remove("selected");
      // });

      if (variant_image.closest(".swiper-slide-item")) {
        variant_image.closest(".swiper-slide-item").classList.add("selected", "swiper-slide");
        variant_image.closest(".swiper-slide-item").classList.remove("hidden");
      }
      variant_image.classList.add("selected");

      const productMedias = document.querySelector('product-medias');
      if (productMedias && productMedias.swiper) {
        // Index réel dans le Swiper (les médias globaux / vidéos / modèles 3D précèdent les photos de variante)
        productMedias.swiper.update();
        const variantSlide = variant_image.closest(".swiper-slide-item");
        const slideIndex = variantSlide ? Array.from(productMedias.swiper.slides).indexOf(variantSlide) : -1;
        console.log('[VariantSelects] Sliding to index:', slideIndex);
        if (slideIndex >= 0) {
          productMedias.swiper.slideTo(slideIndex);
        }
      }
    }

    const selectedImage = document.querySelector(".image__variant.selected");
    if (selectedImage) {
      const stickyBarImage = document.querySelector(".product-sticky-bar__image");
      if (stickyBarImage) {
        stickyBarImage.src = selectedImage.src;
        console.log('[VariantSelects] Updated sticky bar image');
      }
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

window.addEventListener("load", () => {
  toggleAlignBottom();
  window.addEventListener("resize", toggleAlignBottom);
});

function toggleAlignBottom() {
  if (
    window.innerWidth >= 990 &&
    document.querySelector(".product-form__container")
  ) {
    let description_height =
      document.querySelector(".product-form__container").offsetHeight + 150;
    if (document.querySelectorAll(".image__variant:not(.hidden").length == 0) {
      if (window.innerHeight < description_height) {
        document
          .querySelector(".main-product__form")
          .classList.add("align-bottom");
        document.querySelector(".main-product").classList.add("align-bottom");
      } else {
        document
          .querySelector(".main-product__form")
          .classList.remove("align-bottom");
        document
          .querySelector(".main-product")
          .classList.remove("align-bottom");
      }
    }
  }
}

class productCard extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;

    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: false,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        990: {
          allowTouchMove: false,
        },
      },
      on: {
        slideChange: (swiper) => {
          this.handleVideoPlayback(swiper);
        },
        slideChangeTransitionEnd: (swiper) => {
          this.handleVideoPlayback(swiper);
        },
      },
    });

    setTimeout(() => {
      this.handleVideoPlayback(this.swiper);
    }, 100);
  }

  handleVideoPlayback(swiper) {
    if (!swiper) return;

    const allSlides = swiper.slides;
    allSlides.forEach((slide, index) => {
      const video = slide.querySelector("video");
      if (video) {
        if (index === swiper.activeIndex) {
          video.currentTime = 0;
          video.muted = true;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });
  }
}

customElements.define("product-card", productCard);

// (function () {
//   var scrollFired = false;

//   function saveScroll() {
//     if (window.localStorage) {
//       window.localStorage.setItem(
//         "scrollLeftTop",
//         window.pageXOffset + "," + window.pageYOffset
//       );

//     }
//   }

//   function autoScroll() {
//     scrollFired = true;
//     if (window.localStorage) {
//       var xy = window.localStorage.getItem("scrollLeftTop");
//       if (xy) {
//         var a = xy.split(",");
//         var x = a[0];
//         var y = a[1];
//         window.scroll(x, y);
//       }
//     }
//   }

//   function onLoadAutoScroll() {
//     if (scrollFired === false) {
//       //Prevent scroll if run DOMContentLoaded
//       autoScroll();
//     }
//   }

//   window.addEventListener("DOMContentLoaded", autoScroll, false);
//   window.addEventListener("load", onLoadAutoScroll, false); //If DOMContentLoaded not "run"
//   window.addEventListener("scroll", saveScroll, false);
// })();

class sliderCollection extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;

    this.initSlider();
    setTimeout(this.resizeFeaturedPicture.bind(this), 500);
    window.addEventListener("resize", this.resizeFeaturedPicture.bind(this));

    this.addEventListener("reload", () => {
      this.swiper.destroy();
      this.initSlider();
    });
  }

  initSlider() {
    if (this.dataset.enableSlider == "false") return;
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 16,
      cssMode: true,
      centerInsufficientSlides: true,
      preventClicks: true,
      preventClicksPropagation: true,
      touchMoveStopPropagation: false,
      a11y: false,
      speed: 400,
      threshold: 15,
      navigation: {
        nextEl: this.querySelector(
          ".swiper-collection-product-container > .swiper-buttons .swiper-button-next"
        ),
        prevEl: this.querySelector(
          ".swiper-collection-product-container > .swiper-buttons .swiper-button-prev"
        ),
      },
      breakpoints: {
        989: {
          cssMode: false,
        },
      },
    });
  }

  resizeFeaturedPicture() {
    if (this.querySelector(".slider-collection__featured__image")) {
      this.querySelector(".slider-collection__featured__image").style.height =
        this.querySelector(".product-card__media").getBoundingClientRect()
          .height + "px";
    }
  }
}

customElements.define("slider-collection", sliderCollection);
